module.exports = __webpack_public_path__ + "media/images/icons/chat-46d26267370e3802f88d226348a0bad3.svg";